import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const DocumentCard = ({ 
  document, 
  onPreview, 
  onEdit, 
  onDelete 
}) => {
  const getFileIcon = (type) => {
    if (type?.includes('pdf')) return 'FileText';
    if (type?.includes('image')) return 'Image';
    return 'File';
  };

  const formatFileSize = (bytes) => {
    if (!bytes) return '0 B';
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  };

  const isImage = document?.type?.includes('image');
  const isPDF = document?.type?.includes('pdf');

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden hover:shadow-card transition-smooth group">
      <div 
        onClick={() => onPreview(document)}
        className="cursor-pointer"
      >
        {isImage && (
          <div className="aspect-video bg-muted overflow-hidden">
            <Image
              src={document?.url}
              alt={document?.alt}
              className="w-full h-full object-cover group-hover:scale-105 transition-smooth"
            />
          </div>
        )}

        {isPDF && (
          <div className="aspect-video bg-muted overflow-hidden relative">
            <iframe
              src={`${document?.url}#page=1&view=FitH`}
              title={document?.title || document?.name}
              className="w-full h-full pointer-events-none"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-transparent to-muted/30" />
          </div>
        )}

        {!isImage && !isPDF && (
          <div className="aspect-video bg-muted flex items-center justify-center">
            <Icon 
              name={getFileIcon(document?.type)} 
              size={48} 
              color="var(--color-muted-foreground)" 
            />
          </div>
        )}
      </div>
      <div className="p-4">
        <h4 className="text-sm font-semibold text-foreground mb-1">
          {document?.title || document?.name}
        </h4>
        {document?.description && (
          <p className="text-xs text-muted-foreground mb-3 line-clamp-2">
            {document?.description}
          </p>
        )}
        <div className="flex items-center justify-between text-xs text-muted-foreground mb-3">
          <span>{formatFileSize(document?.size)}</span>
          <span>{new Date(document.uploadedAt)?.toLocaleDateString()}</span>
        </div>
        
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            iconName="Eye"
            iconPosition="left"
            onClick={() => onPreview(document)}
            className="flex-1"
          >
            Preview
          </Button>
          <Button
            variant="ghost"
            size="sm"
            iconName="Edit2"
            onClick={() => onEdit(document)}
          />
          <Button
            variant="ghost"
            size="sm"
            iconName="Trash2"
            onClick={() => onDelete(document)}
          />
        </div>
      </div>
    </div>
  );
};

export default DocumentCard;